export default {
    UPDATE_GEOFENCES: 'UPDATE_GEOFENCES',
};
